import { render, staticRenderFns } from "./RoundChart.vue?vue&type=template&id=fd604154&"
import script from "./RoundChart.vue?vue&type=script&lang=js&"
export * from "./RoundChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports